import { Link } from "react-router-dom";
import { BIZ } from "@/data/site";
import { bySide } from "@/data/coverage";
import { useLang } from "@/i18n/LanguageContext";

const Col = ({ title, children }) => {
  const { t } = useLang();
  return (
    <div>
      <h3 className="font-sans text-[13px] font-semibold text-white/90">{t(title)}</h3>
      <ul className="mt-3 space-y-2">{children}</ul>
    </div>
  );
};

const FLink = ({ to, children }) => {
  const { t } = useLang();
  return (
    <li>
      <Link to={to} className="text-[13.5px] text-white/60 transition-colors hover:text-white">
        {typeof children === "string" ? t(children) : children}
      </Link>
    </li>
  );
};

export const SiteFooter = () => {
  const { t } = useLang();
  return (
  <footer className="bg-[var(--ink-deep)] text-white">
    <div className="wrap py-14">
      <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
        <div className="col-span-2 md:col-span-4 lg:col-span-1">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[4px] bg-white p-1">
              <img src="/artha-logo.png" alt="Artha Insurance LLC logo" width="96" height="32" loading="lazy" className="h-8 w-auto" />
            </span>
            <span className="font-display text-lg" style={{ color: "#ffffff" }}>Artha Insurance</span>
          </div>
          <p className="mt-4 max-w-[34ch] text-[13.5px] leading-relaxed text-white/60">
            {t("Independent property and casualty agency.")} {BIZ.address}.
          </p>
          <p className="mt-3 text-[13.5px] text-white/60">
            <a href={BIZ.phoneHref} className="hover:text-white">{BIZ.phone}</a>
            <br />
            <a href={BIZ.emailHref} className="hover:text-white">{BIZ.email}</a>
            <br />
            {t("Monday to Friday, 8:30 to 5:30 Central")}
          </p>
        </div>
        <Col title="Business">
          {bySide("business").map((c) => (
            <FLink key={c.slug} to={`/coverage/${c.slug}`}>{c.name}</FLink>
          ))}
        </Col>
        <Col title="Personal & specialty">
          {bySide("personal").map((c) => (
            <FLink key={c.slug} to={`/coverage/${c.slug}`}>{c.name}</FLink>
          ))}
          <FLink to="/specialty">All specialty lines</FLink>
        </Col>
        <Col title="Service">
          <FLink to="/quote">Get my quote</FLink>
          <FLink to="/policy-review">Free policy review</FLink>
          <FLink to="/claims">Report a claim</FLink>
          <FLink to="/certificate">Request a certificate</FLink>
          <FLink to="/pay">Pay my premium</FLink>
          <FLink to="/login">Customer login</FLink>
        </Col>
        <Col title="Company">
          <FLink to="/why-us">Why us</FLink>
          <FLink to="/privacy">Privacy policy</FLink>
          <FLink to="/terms">Terms of use</FLink>
          <FLink to="/accessibility">Accessibility</FLink>
        </Col>
      </div>

      <div className="mt-12 border-t border-white/15 pt-6">
        <p className="max-w-[90ch] text-[12px] leading-relaxed text-white/45">
          {t("Artha Insurance LLC is licensed as an insurance agency in the State of Texas only. Agency NPN {npnAgency}. Individual NPN {npnIndividual}. Coverage descriptions on this site are summaries; the issued policy controls. Nothing on this site binds, activates, or alters insurance coverage. Complaints may be directed to the Texas Department of Insurance at 1-800-252-3439.", { npnAgency: BIZ.npnAgency, npnIndividual: BIZ.npnIndividual })}
        </p>
        <p className="mt-3 text-[12px] text-white/45">
          © {new Date().getFullYear()} Artha Insurance LLC. {t("All rights reserved.")}
        </p>
      </div>
    </div>
  </footer>
  );
};
